import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './film-intro.css';
import App from './App';
import { startBuildGuard } from './buildGuard';

// GlitchTip (Sentry-compatible) error tracking. No-op unless REACT_APP_SENTRY_DSN
// is baked in at build time. The default BrowserSession integration is dropped —
// GlitchTip has no release-health/session ingest.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: (defaults) =>
      defaults
        .filter((integration) => integration.name !== 'BrowserSession')
        .concat(Sentry.browserTracingIntegration()),
    tracesSampleRate: 0.1,
  });
}

startBuildGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
